module.exports = __webpack_public_path__ + "static/media/eg.e362f359.png";